import React, { useEffect, useState } from "react";
import "./SearchForm.css";
import Select from "react-select";
import axios from "axios";
import CubeLoader from "./../Assets/Images/cube-loader.gif";
const SearchForm = ({ position, onSearch, isSearching }) => {
  const [keywords, setKeywords] = useState("");
  const [inputValue, setInputValue] = useState("");
  const [location, setLocation] = useState("");
  const [category, setCategory] = useState("");
  const [jobFunctions, setJobFunctions] = useState([]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    let keywords = "";
    let jobId = "";

    if (isNaN(inputValue)) {
      jobId = inputValue; // Treat as Number
    } else {
      keywords = inputValue; // Treat as keywords
    }
    if (onSearch) {
      await onSearch({ keywords, location, category, jobId });
    }
  };

  useEffect(() => {
    const fetchJobFunctions = () => {
      axios
        .post(`https://hrms-api.apisod.ai/api/job-functions`, {})
        .then((response) => {
          const { data } = response.data;
          const formattedData = data.map((item) => ({
            value: item.id,
            label: item.name,
          }));
          setJobFunctions(formattedData);
        })
        .catch((error) => {
          console.log("Error fetching job functions:", error);
        });
    };
    fetchJobFunctions();
  }, []);

  
  return (
    <>
      {isSearching && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            zIndex: 9999,
            backdropFilter: "blur(5px)",
          }}
        >
          <img src={CubeLoader} alt="Loading..." />
        </div>
      )}
      <div
        className={`banner-area ${
          position === "over" ? "position-absolute w-100 h-100" : ""
        }`}
        style={
          position === "over"
            ? {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }
            : {}
        }
      >
        <div
          className="container-fluid"
          style={{ filter: isSearching ? "blur(5px)" : "none" }}
        >
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="banner-content" style={{ padding: "15px" }}>
                <div
                  className="banner-form"
                  style={{
                    border: "1px solid #ccc",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-lg-3 col-sm-4">
                        <div className="form-group">
                          <input
                            className="form-control"
                            type="text"
                            title="Keywords / Job Title / Job Id"
                            placeholder="Keywords / Job Title / Job Id"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value)}
                          />
                          <i className="ri-search-line"></i>
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-4">
                        <div className="form-group">
                          <input
                            className="form-control"
                            type="text"
                            title="Location"
                            placeholder="City or Postcode"
                            value={location}
                            onChange={(e) => setLocation(e.target.value)}
                          />
                          <i className="ri-map-pin-line"></i>
                        </div>
                      </div>

                      <div
                        className="col-lg-3 col-sm-4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <div
                          className="form-group select-group"
                          style={{ width: "100%" }}
                          title="Select Category"
                        >
                          <Select
                            options={jobFunctions}
                            onChange={(e) => setCategory(e?.value)}
                            
                          />
                        </div>
                      </div>

                      <div className="col-lg-3 col-sm-12">
                        <button
                          type="submit"
                          className="submit-btn border-radius-5"
                          disabled={isSearching}
                        >
                          {isSearching ? "Searching..." : "Find Jobs"}
                        </button>
                      </div>
                    </div>
                  </form>
                </div>{" "}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>
    </>
  );
};
export default SearchForm;
